import { createAction } from 'redux-actions'

// Actions
export const UPDATE_LOADS = 'customerPortal/loadsInTransit/UPDATE_LOADS'
export const UPDATE_TOTAL = 'customerPortal/loadsInTransit/UPDATE_TOTAL'
export const UPDATE_MODIFIED_LOADS = 'customerPortal/loadsInTransit/UPDATE_MODIFIED_LOADS'
export const UPDATE_SORT_FIELD = 'customerPortal/loadsInTransit/UPDATE_SORT_FIELD'
export const TOGGLE_SORT_DIRECTION = 'customerPortal/loadsInTransit/TOGGLE_SORT_DIRECTION'
export const SET_SORT_DIRECTION = 'customerPortal/loadsInTransit/SET_SORT_DIRECTION'
export const RESET = 'customerPortal/loadsInTransit/RESET'

const initialState = {
  title: `In Transit`,
  loads: [],
  total: 0,
  modifiedLoads: [],
  sortField: `pickupDate`,
  direction: `desc`
}

// Reducer
export default function loadsInTransit (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOADS:
      return {
        ...state,
        loads: action.payload
      }
    case UPDATE_TOTAL:
      return {
        ...state,
        total: action.payload
      }
    case UPDATE_MODIFIED_LOADS:
      return {
        ...state,
        modifiedLoads: action.payload
      }
    case UPDATE_SORT_FIELD:
      return {
        ...state,
        sortField: action.payload,
        direction: `desc`
      }
    case TOGGLE_SORT_DIRECTION:
      return {
        ...state,
        direction: state.direction === `asc` ? `desc` : `asc`
      }
    case SET_SORT_DIRECTION:
      return {
        ...state,
        direction: action.payload
      }
    case RESET:
      return initialState
    default:
      return state
  }
}

// Action Creators
export const updateLoadsInTransit = createAction(UPDATE_LOADS)
export const updateTotalLoadsInTransit = createAction(UPDATE_TOTAL)
export const updateModifiedLoadsInTransit = createAction(UPDATE_MODIFIED_LOADS)
export const updateSortFieldLoadsInTransit = createAction(UPDATE_SORT_FIELD)
export const toggleSortDirectionLoadsInTransit = createAction(TOGGLE_SORT_DIRECTION)
export const setSortDirectionLoadsInTransit = createAction(SET_SORT_DIRECTION)
export const resetLoadsInTransit = createAction(RESET)